import { render } from "./Workspace.vue?vue&type=template&id=7c9ad853&scoped=true&ts=true"
import script from "./Workspace.vue?vue&type=script&lang=ts"
export * from "./Workspace.vue?vue&type=script&lang=ts"

import "./Workspace.vue?vue&type=style&index=0&id=7c9ad853&scoped=true&lang=scss"
import "./Workspace.vue?vue&type=style&index=1&id=7c9ad853&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9ad853"]])

export default __exports__